import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=06a5dc6b&scoped=true"
import script from "./ContactInformation.vue?vue&type=script&lang=ts"
export * from "./ContactInformation.vue?vue&type=script&lang=ts"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=06a5dc6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a5dc6b",
  null
  
)

export default component.exports